import _axios from "@/axios";
import { reactive, ref } from "@vue/composition-api";
import { showSnackBar } from "./snackbar";
import { handleFormErrors } from "./form-error";
import router from "../router";

export function useProfile() {
  const profiles = ref([]);
  const profile = ref({});
  const attributesChoice = [
    { text: "Colubris-AVPair", value: "Colubris-AVPair" },
    { text: "Tunnel-Type", value: "Tunnel-Type" },
    { text: "Tunnel-Medium-Type", value: "Tunnel-Medium-Type" },
    { text: "Tunnel-Private-Group-ID", value: "Tunnel-Private-Group-ID" },
  ];
  const profileData = reactive({
    createProfileDialog: false,
    editProfileDialog: false,
    profileForm: {
      attributes: [],
    },
    profileFormRef: null,
    rules: {
      descriptionRules: [(v) => !!v || "Champ obligatoire"],
      labelRules: [(v) => !!v || "Champ obligatoire"],
    },
    isLoading: false,
  });

  function listProfiles(partnerId = null) {
    let routePath = "";
    if (partnerId != null) {
      routePath = "/list-profile/partner/" + partnerId;
    }

    return _axios
      .get(routePath)
      .then((response) => {
        profiles.value = response.data.data;
      })
      .catch(() => {
        alert(
          "Une erreur est survenue, si cela se reproduit contactez le support"
        );
      });
  }

  function showProfile(id) {
    return _axios
      .get("/profile/" + id)
      .then((response) => {
        profile.value = response.data.data;
      })
      .catch(() => {
        alert(
          "Une erreur est survenue, si cela se reproduit contactez le support"
        );
      });
  }

  function createProfile(partnerId) {
    profileData.isLoading = true;
    profileData.createProfileDialog = true;
    if (partnerId != null) {
      profileData.profileForm.partner = partnerId;
    }

    if (profileData.profileFormRef != null) {
      const isValid = profileData.profileFormRef.validate();
      if (!isValid) {
        profileData.isLoading = false;
        return;
      }
    }

    return _axios
      .post("/create-profile", profileData.profileForm)
      .then((response) => {
        const profile = response.data.data;
        listProfiles(partnerId);
        profileData.createProfileDialog = false;
        showSnackBar();
        router.push({ name: "profil-details", params: { id: profile.id } });
      })
      .catch((error) => {
        const formErrors = error.response.data.violations;
        handleFormErrors(
          formErrors,
          profileData.rules,
          profileData.profileFormRef
        );
      })
      .finally(() => {
        profileData.isLoading = false;
      });
  }

  function updateProfile(profile) {
    profileData.isLoading = true;
    profileData.editProfileDialog = true;
    if (profileData.profileFormRef != null) {
      const isValid = profileData.profileFormRef.validate();
      if (!isValid) {
        profileData.isLoading = false;
        return;
      }
    }

    return _axios
      .put("/profile/" + profile.id, profileData.profileForm)
      .then((response) => {
        showSnackBar();
        profile.value = response.data.data;
        profileData.editProfileDialog = false;
      })
      .catch((error) => {
        console.log(error);
        const formErrors = error.response.data.violations;
        handleFormErrors(
          formErrors,
          profileData.rules,
          profileData.profileFormRef
        );
      })
      .finally(() => {
        profileData.isLoading = false;
      });
  }

  function deleteProfile(profile) {
    return _axios
      .delete("/profile/" + profile.id)
      .then(() => {
        listProfiles(profile.partner.id);
        showSnackBar();
      })
      .catch(() => {
        alert(
          "Une erreur est survenue, si cela se reproduit contactez le support"
        );
      });
  }

  return {
    profiles,
    listProfiles,
    createProfile,
    updateProfile,
    deleteProfile,
    showProfile,
    profile,
    attributesChoice,
    profileData,
  };
}
